import * as angular from 'angular';
import { HttpService } from '../../../../app.common/modules/api/http.service';
import { RetailerService } from '../../api/retailer.service';
import { AccountService } from '../../account/account.service';
import { DesignRequest } from '../../core';

export class DesignRequestService {
    static $inject = ['$q', 'http', 'accountService', 'retailerService'];
    constructor(
        private $q: ng.IQService,
        private http: HttpService,
        private accountService: AccountService,
        private retailerService: RetailerService,
    ) { }

    needHelp = (sessionID: number, data: DesignRequest) => {
        return this.http.post<void>(this.retailerService.designRequest(sessionID), data);
    }

    deleteFiles(sessionID: number) {
        return this.http.delete<void>(this.retailerService.designRequest(sessionID));
    }

    getAuthorizationBearer() {
        return { 'Authorization': 'Bearer ' + this.accountService.getRetailerToken() };
    }

    getSessionID() {
        return this.http.post<number>(this.retailerService.designRequest(), null);
    }

    getUploaderUrl(sessionID: number): string {
        return this.retailerService.designRequestFile(sessionID);
    }

    /* async getUserData() {
        try {
            if (this.accountService.userData.isEmpty()) {
                await this.accountService.getProfile();
            }
        } catch (error) {
            return this.$q.reject(error);
        }
        return this.accountService.userData;
    } */
}

angular
    .module('naut')
    .service('designRequestService', DesignRequestService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/campaigns/services/designRequest.service.ts